<div class="dynamic-block" [ngClass]="[template.general.styleType]">
  @if (!shrinkImageContainer) {
    <div
      class="image-container"
      [ngStyle]="{
        'max-width': block.imageContainerWidth ? block.imageContainerWidth + 'px' : 'none',
        'max-height': block.imageContainerHeight ? block.imageContainerHeight + 'px' : 'none',
        'min-width': block.imageContainerWidth ? block.imageContainerWidth + 'px' : 'none',
        'min-height': block.imageContainerHeight ? block.imageContainerHeight + 'px' : 'none',
      }">
      @if (block | blockImageSrc) {
        <img [src]="block | blockImageSrc" />
      }
    </div>
  }
  <div
    class="dynamic-block__text-stack"
    [ngClass]="[template.general.styleType, isPerRowTimerEnabled ? 'per-row-timer' : '']">
    <b class="dynamic-block__title" [style.display]="isPerRowTimerEnabled ? 'block' : 'inline'">{{ block.title }}</b>
    @if (isPerRowTimerEnabled) {
      <span [innerHTML]="combinedTextHtml | safe: 'html'"></span>
    } @else {
      <div>
        @for (element of textElements; track $index) {
          <div [innerHTML]="getElementHtml(element) | safe: 'html'"></div>
        }
      </div>
    }
  </div>
</div>
